var C9rProductDetailConversion = /* @__PURE__ */ ((C9rProductDetailConversion2) => {
  C9rProductDetailConversion2["addToCart"] = "add_to_cart";
  C9rProductDetailConversion2["addToWishlist"] = "add_to_wishlist";
  C9rProductDetailConversion2["preorder"] = "pre-order";
  return C9rProductDetailConversion2;
})(C9rProductDetailConversion || {});
export {
  C9rProductDetailConversion
};
//# sourceMappingURL=constructorTracking.mjs.map
